<template>
    <span>
        <b-btn block variant="warning" class="font-weight-bold" @click="showModal = true">
            Update Table Number
        </b-btn>
        <c-modal
            v-model="showModal"
            cancel-label="Never mind"
            centered
            title="Update table number"
            :tag="false"
            confirm-label="Update table number"
            :progressing="loading"
            size="md"
            @submit="updateTableNumber"
            @show="shown"
        >
            <template>
                 <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
                    <ul class="m-0 px-1">
                        <li v-for="err in errors.all()" :key="err">{{err}}</li>
                    </ul>
                </b-alert>
                <div>
                <b-input-group prepend="Table number" class="my-3">
                    <b-input type="text" v-model="tableNo" v-validate="'required|max:5'" name="Table number"/>
                </b-input-group>
            </div>
            </template>
        </c-modal>
    </span>
</template>

<script>
    import CModal from "./Cmodal";
    export default {
        name: "updateTableNumber",
        components: {CModal},
        props: {
            tableNumber: {required: true},
            orderId: {required: true}
        },
        data () {
            return {
                showModal: false,
                tableNo: this.tableNumber,
                loading: false
            }
        },
        methods: {
            shown () {
              this.tableNo = this.tableNumber
            },
            updateTableNumber () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        const model = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            OrderId: this.orderId,
                            TableNumber: this.tableNo
                        }
                        this.loading = true
                        this.$api.getRestaurant.UpdateOrderTableNumber(model).then(res => {
                            this.loading = false
                            if (res.success) {
                                this.$emit('updateOrders')
                                this.showModal = false
                            } else {
                                this.$showError(res.message)
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
